export default {"src":"/_next/static/media/static-tools.a8818a37.svg","height":530,"width":479,"blurWidth":0,"blurHeight":0};